"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Actions = require("../../store/actions/Actions");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ClearAllFiltersBtn = function ClearAllFiltersBtn(_ref) {
  var Component = _ref.Component,
    onClearAllFilters = _ref.onClearAllFilters,
    _ref$activeFilters = _ref.activeFilters,
    activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters;
  var dispatchClearAllFilters = function dispatchClearAllFilters() {
    return onClearAllFilters();
  };
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    disable = _ref3[0],
    setDisable = _ref3[1];
  (0, _react.useEffect)(function () {
    if (activeFilters) {
      var filters = Object.keys(activeFilters).reduce(function (count, key) {
        // eslint-disable-next-line no-param-reassign
        if (activeFilters[key].length > 0) {
          count += 1;
        }
        return count;
      }, 0);
      if (filters === 0) {
        setDisable(true);
      } else {
        setDisable(false);
      }
    }
  }, [activeFilters]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, {
    onClearAllFilters: dispatchClearAllFilters,
    disable: disable
  }));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClearAllFilters: function onClearAllFilters() {
      dispatch((0, _Actions.clearAllFilters)());
    }
  };
};
var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ClearAllFiltersBtn);
exports.default = _default;